import { AnyAction } from '@reduxjs/toolkit';
import {
  QUICK_SEARCH_CATEGORY_ERROR,
  QUICK_SEARCH_CATEGORY_INPUT_ACTIVE,
  QUICK_SEARCH_CATEGORY_QUERY,
  QUICK_SEARCH_CATEGORY_RECEIVE,
  QUICK_SEARCH_CATEGORY_REQUEST,
  QUICK_SEARCH_CATEGORY_RESET,
} from '../constants';

interface QuickSearchCategoryState {
  categoryQuery: string;
  resultLinks: any[];
  showResult: boolean;
  inputActive: boolean;
  isLoading: boolean;
  error?: any;
}

const DEFAULT_STATE: QuickSearchCategoryState = {
  categoryQuery: '',
  resultLinks: [],
  showResult: false,
  inputActive: false,
  isLoading: false,
  error: null,
};

export const quickSearchCategory = (
  state = DEFAULT_STATE,
  action: AnyAction
): QuickSearchCategoryState => {
  switch (action.type) {
    case QUICK_SEARCH_CATEGORY_QUERY:
    case QUICK_SEARCH_CATEGORY_RECEIVE:
    case QUICK_SEARCH_CATEGORY_INPUT_ACTIVE:
    case QUICK_SEARCH_CATEGORY_REQUEST:
    case QUICK_SEARCH_CATEGORY_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case QUICK_SEARCH_CATEGORY_RESET:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
